import Image from './Image.jsx';

export default Image;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/Image/index.js